import InternCoursePage from '../InternCoursePage';
import useInternCourses from '../../../../hooks/useInternCourses';

export default function InternYouthpartysPage() {
  const { courses, loading, error, reload } = useInternCourses('youthparty');
  return (
    <InternCoursePage
      courses={courses}
      loading={loading}
      error={error}
      pageTitle={'Jugend'}
      category={'youthparty'}
      reload={reload}
    />
  );
}
